import { useNotifier } from '../components/NotificationsStack';

/**
 * Hook for pushing app-wide toast notifications.
 *
 * Thin adapter over the global `NotificationsStack` system: toasts are no
 * longer held in local component state — they render through the global
 * stack host mounted in `App.js` (top-center stack, blueberry `Toast`,
 * 5s auto-expire).
 *
 * The previous `toasts`/`addToast`/`removeToast` surface is kept for
 * call-signature compatibility: `toasts` is always an empty array
 * (visibility lives in the global stack) and `removeToast` is a no-op,
 * since the stack auto-expires its toasts.
 */
export const useToast = () => {
    const { pushNotif, successNotif, dangerNotif } = useNotifier();

    const success = (message) => successNotif(message);
    const error = (message) => dangerNotif(message);
    const warning = (message) => dangerNotif(message);
    const info = (message) => pushNotif({ message });

    return {
        toasts: [],
        addToast: (message, type = 'info') => {
            if (type === 'error' || type === 'warning') {
                dangerNotif(message);
            } else {
                pushNotif({ message });
            }
        },
        removeToast: () => {},
        success,
        error,
        warning,
        info
    };
};

export default useToast;
